// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from "wix-location";
//import wixWindow from 'wix-window';

$w.onReady(function () {
	//const desktop = wixWindow.formFactor === 'Desktop';

	var templates = "https://www.wix.com/wix-lp/designers-playground/templates";
	if (wixLocation.url === templates) {
		// $w('#button104').link = "https://editor.wix.com/html/editor/web/renderer/new?metaSiteId=ebbec735-2eab-4879-8011-00885f4cacde&siteId=c41d20fe-577c-4c3d-98ff-c8c149faee17&editorSessionId=585A29D0-9C29-492C-9720-742030E581D3";
	} else {
		// $w('#button104').link = templates;
	}
//
//	$w('#repeater1').forEachItem(($item, itemData, index) => {
//		if (index >= 4) {
//			$item('#container1').collapse()
//		}
//	})

//	$w('#button213').onClick(() => {
//		$w('#repeater1').forEachItem(($item, itemData, index) => {
//			if (index >= 4) {
//				$item('#container1').expand()
//			}
//		})
//	})
});

//		.then(()=>{
//			console.log('hide temp');
//			return $w(textId).hide('FadeOut');
//		})
//		.then(()=>{
//			console.log('change temp');
//			$w(textId).text = newText;
//		})
//		.then(()=>{
//			console.log('show temp');
//			return $w(textId).show('FadeIn');
//		})
//		.then(()=>{
//			console.log('show deg');
//			return $w('#shape6').show('FadeIn');
//		});
//	}
//}



export function onItemClicked(event) {
	console.log("x")
}

export function _columnStrip86_click(event) {
	$w("#columnStrip90").collapse()
	$w("#columnStrip91").collapse()
	if($w("#columnStrip87").collapsed){
		$w("#columnStrip87").expand()
	}else{
		$w("#columnStrip87").collapse()
	}
	
}

export function _columnStrip88_click(event) {
	$w("#columnStrip87").collapse()
	$w("#columnStrip91").collapse()
	if($w("#columnStrip90").collapsed){
		$w("#columnStrip90").expand()
	}else{
		$w("#columnStrip90").collapse()
	}
}

export function _columnStrip89_click(event) {
	$w("#columnStrip90").collapse()
	$w("#columnStrip87").collapse()
	if($w("#columnStrip91").collapsed){
		$w("#columnStrip91").expand()
	}else{
		$w("#columnStrip91").collapse()
	}
}

export function anchor2_viewportLeave(event) {
	/*$w("#blue").hide();
	$w("#white").show();*/
}

export function columnStrip62_viewportEnter(event) {
	/*$w("#blue").show();
	$w("#white").hide();*/
}

export function columnStrip85_viewportEnter(event) {
	/*$w("#blue").hide();
	$w("#white").show();*/
}

import { timeline } from 'wix-animations'
$w.onReady(function () {

timeline({yoyo: true, repeat: -1})
  .add($w('#text337', ), { x: 0, duration: 250, easing:'easeOutQuad' })
  .add($w('#text337'), { x: 10, duration: 250, easing:'easeOutQuad' })
  .play()

timeline({yoyo: true, repeat: -1})
  .add($w('#text474', ), { x: 0, duration: 250, easing:'easeOutQuad' })
  .add($w('#text474'), { x: 10, duration: 250, easing:'easeOutQuad' })
  .play()

timeline({yoyo: true, repeat: -1})
  .add($w('#text475', ), { x: 0, duration: 250, easing:'easeOutQuad' })
  .add($w('#text475'), { x: 10, duration: 250, easing:'easeOutQuad' })
  .play()

  timeline({repeat: -1})
  .add($w('#vectorImage15'), { duration: 35000, rotate: 360, easing: 'easeLinear' })
  .play()

  });